import { Box, useMediaQuery } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { Theme, useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import MoreOptions from './MoreOptions/MoreOptions';
import PageTitle from './PageTitle';
import ToggleNav from './ToggleNav';
import UserAvatar from './UserAvatar';

const appBarSx = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  backgroundImage: 'none',
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  position: 'relative',
  zIndex: 900,
});

const toolbarSx = (theme: Theme) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
});

const rightMenuSx = (theme: Theme) => ({
  display: 'flex',
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  columnGap: theme.spacing(1.5),
});

const rightMenuItemSx = {
  display: 'flex',
};

export interface MenuItem {
  component: React.ReactNode;
  priority?: number;
}

export interface NavBarProps {
  pageTitle: string;
  rightMenuItems: MenuItem[];
  navBarRef?: React.RefObject<any>;
}

const NavBar: React.FC<NavBarProps> = (props) => {
  const {
    pageTitle,
    rightMenuItems,
    navBarRef,
  } = props;
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down('sm'));

  const sortedRightMenuItems = rightMenuItems?.sort(
    (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
  );

  return (
    <AppBar
      sx={appBarSx}
      position="sticky"
      id="navBar"
      color="inherit"
      ref={navBarRef}
    >
      <Toolbar sx={toolbarSx} disableGutters>
        <ToggleNav />
        <PageTitle pageTitle={pageTitle} data-testid={`${pageTitle}-testId`} />
        <Box sx={rightMenuSx}>
          {mobileSize && sortedRightMenuItems.length > 0 ? (
            <MoreOptions navBarMenuItems={sortedRightMenuItems} />
          ) : (
            sortedRightMenuItems.map((navItem) => (
              <Box sx={rightMenuItemSx} key={navItem.priority}>
                {navItem.component}
              </Box>
            ))
          )}
        </Box>
        <UserAvatar />
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
